//src/pages/PreviewEmpresasCSV.js
import React, { useState } from "react";
import Papa from "papaparse";
import axios from "../axiosConfig";
import { toast } from "react-toastify";

import {
  CheckCircle2,
  Eye,
  FileSpreadsheet,
  Search,
  Upload,
} from "lucide-react";

import "./PreviewEmpresasCSV.css";

function PreviewEmpresasCSV() {
  const [arquivo, setArquivo] = useState(null);
  const [dadosCSV, setDadosCSV] = useState([]);
  const [previewAtivo, setPreviewAtivo] = useState(false);
  const [importando, setImportando] = useState(false);

  const handleArquivoSelecionado = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setArquivo(file);
    setPreviewAtivo(false);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,

      complete: (result) => {
        setDadosCSV(Array.isArray(result.data) ? result.data : []);
        setPreviewAtivo(true);
      },

      error: () => toast.error("Erro ao ler o arquivo CSV."),
    });
  };

  const handleImportar = async () => {
    if (!arquivo) {
      toast.warning("Selecione um arquivo CSV antes de importar.");
      return;
    }

    const formData = new FormData();
    formData.append("arquivo", arquivo);

    try {
      setImportando(true);

      await axios.post("/empresas/importar", formData);

      toast.success("Importação concluída com sucesso!");

      setDadosCSV([]);
      setPreviewAtivo(false);
      setArquivo(null);
    } catch (err) {
      toast.error("Erro ao importar empresas.");
      console.error(err);
    } finally {
      setImportando(false);
    }
  };

  return (
    <div className="previewEmpresasAdmin-page">
      <div className="previewEmpresasAdmin-topbar">
        <div>
          <span className="previewEmpresasAdmin-kicker">
            Importação avançada
          </span>

          <h2>Preview de importação de empresas</h2>

          <p>
            Visualize os dados do CSV antes da importação definitiva para validar
            os registros que serão incluídos no Tikpontos.
          </p>
        </div>
      </div>

      <div className="previewEmpresasAdmin-grid">
        <div className="previewEmpresasAdmin-card">
          <div className="previewEmpresasAdmin-cardHeader">
            <div className="previewEmpresasAdmin-icon">
              <Upload size={20} />
            </div>

            <div>
              <h3>Selecionar arquivo CSV</h3>
              <span>
                Faça upload do arquivo contendo os dados das empresas.
              </span>
            </div>
          </div>

          <div className="previewEmpresasAdmin-content">
            <div className="previewEmpresasAdmin-info">
              <FileSpreadsheet size={16} />

              <span>
                O arquivo deve conter os campos:
                <strong>
                  cnpj, razao_social, logradouro, numero, complemento, bairro,
                  cidade, estado e cep
                </strong>
              </span>
            </div>

            <label className="previewEmpresasAdmin-upload">
              <input
                type="file"
                accept=".csv"
                onChange={handleArquivoSelecionado}
              />

              <div className="previewEmpresasAdmin-uploadBox">
                <Upload size={24} />

                <div>
                  <strong>
                    {arquivo ? arquivo.name : "Selecionar arquivo CSV"}
                  </strong>

                  <span>
                    Clique para escolher um arquivo do computador
                  </span>
                </div>
              </div>
            </label>
          </div>
        </div>

        {previewAtivo && (
          <div className="previewEmpresasAdmin-card preview">
            <div className="previewEmpresasAdmin-cardHeader">
              <div className="previewEmpresasAdmin-icon teal">
                <Eye size={20} />
              </div>

              <div>
                <h3>Visualização prévia</h3>

                <span>
                  {dadosCSV.length.toLocaleString("pt-BR")} registro(s)
                  encontrado(s) no CSV.
                </span>
              </div>
            </div>

            <div className="previewEmpresasAdmin-tableWrapper">
              <table className="previewEmpresasAdmin-table">
                <thead>
                  <tr>
                    <th>CNPJ</th>
                    <th>Razão Social</th>
                    <th>Logradouro</th>
                    <th>Número</th>
                    <th>Complemento</th>
                    <th>Bairro</th>
                    <th>Cidade</th>
                    <th>Estado</th>
                    <th>CEP</th>
                  </tr>
                </thead>

                <tbody>
                  {dadosCSV.map((linha, index) => (
                    <tr key={index}>
                      <td>{linha.cnpj}</td>
                      <td>{linha.razao_social}</td>
                      <td>{linha.logradouro}</td>
                      <td>{linha.numero}</td>
                      <td>{linha.complemento}</td>
                      <td>{linha.bairro}</td>
                      <td>{linha.cidade}</td>
                      <td>{linha.estado}</td>
                      <td>{linha.cep}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="previewEmpresasAdmin-actions">
              <button
                type="button"
                className="previewEmpresasAdmin-btn primary"
                onClick={handleImportar}
                disabled={importando}
              >
                {importando ? (
                  <>
                    <Search size={16} />
                    Importando...
                  </>
                ) : (
                  <>
                    <CheckCircle2 size={16} />
                    Importar agora
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PreviewEmpresasCSV;